import React from 'react';

import { SessionContextConsumer } from './session-context';

const WithSessionContext = WrappedComponent => {
  return props => (
    <SessionContextConsumer>
      {sessionContext => (
        <WrappedComponent {...props} sessionContext={sessionContext} />
      )}
    </SessionContextConsumer>
  );
};

export default WithSessionContext
